import React from "react";
import { Box, Grid } from "@mui/material";

type Props = { mb?: number; mt?: number };
export function CustomBorder(props: Props) {
  return (
    <Grid item xs={12}>
      <Box mb={props.mb || 2} borderBottom={1} mt={props.mt || 1} color={"rgba(0, 0, 0, 0.12)"} />
    </Grid>
  );
}
